export const disableWarnings = () => {
  console.warn = () => {};
};
